import { SelectChangeEvent } from '@mui/material';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { filteredDataGraphic } from 'v2/resources/utils/filteredDataGraphic';
import { useQueryBiometricsParameters } from 'v2/resources/hooks/services/useGraphics';
import {
  useAppDispatch,
  useAppSelector,
} from 'v2/resources/hooks/useAppSelector';
import { IGraphicInfo } from 'v2/resources/types/graphics';
import { setGraphicBiometricsParameters } from 'v2/store/dataChat/slice';

const useBiometricsParameters = () => {
  const dispatch = useAppDispatch();
  const selectedCycle = useAppSelector(
    (state) => state.selectedCycle.selectedCycle
  );

  const [selectedParameter, setSelectedParameter] = useState<string>('default');
  const [selectedNurseries, setSelectedNurseries] = useState<IGraphicInfo[]>(
    []
  );

  const { data: dataBiometricsParameters } = useQueryBiometricsParameters(
    selectedCycle?.id
  );

  const handleChangeParameters = (event: SelectChangeEvent<unknown>) => {
    const { value } = event.target;
    if (String(value).includes('default')) {
      return;
    }
    setSelectedParameter(value as string);
  };

  const handleLoadData = useCallback(() => {
    if (!dataBiometricsParameters) return;

    if (dataBiometricsParameters.labels?.length === 0) {
      setSelectedParameter('default');
    }
    setSelectedParameter(dataBiometricsParameters.labels[0] ?? 'default');
    dispatch(setGraphicBiometricsParameters(dataBiometricsParameters));
  }, [dataBiometricsParameters]);

  const optionsParameters = useMemo(() => {
    const defaultOption = [
      {
        id: 1,
        label: 'Parâmetros',
        value: 'default',
      },
      {
        id: 2,
        label: 'Parâmetros',
        value: 'default2',
      },
    ];

    if (!dataBiometricsParameters) return defaultOption;

    if (dataBiometricsParameters.labels?.length === 0) return defaultOption;

    return [
      ...[defaultOption[0]],
      ...dataBiometricsParameters?.labels.map((label, index) => ({
        id: index + 1,
        label: label,
        value: label,
      })),
    ];
  }, [dataBiometricsParameters]);

  const optionsnNurseries = useMemo(() => {
    if (!dataBiometricsParameters) return [];

    const result = filteredDataGraphic(
      dataBiometricsParameters,
      selectedParameter
    );

    setSelectedNurseries(result);
    return result;
  }, [dataBiometricsParameters, selectedParameter]);

  useEffect(() => {
    handleLoadData();
  }, [handleLoadData]);

  return {
    optionsParameters,
    optionsnNurseries,
    selectedParameter,
    selectedNurseries,

    handleChangeParameters,
    setSelectedNurseries,
  };
};
export default useBiometricsParameters;
